import {createAction} from "redux-act";

export interface IOverallRankingPayload {
	offset?: number;
	limit?: number;
}

export interface IRanking {
	userId: number;
	rank: number | null;
	points: number | null;
	username: string;
}

export interface IOverallRankingResponse {
	rankings: IRanking[];
	next: boolean;
}

export const fetchOverallRanking = createAction<IOverallRankingPayload>();
export const fetchOverallRankingSuccess = createAction<IOverallRankingResponse>();
export const fetchOverallRankingError = createAction();

export const setCurrentPage = createAction<number>();
